import { React, useState, useEffect } from 'react';
import PageHeader from 'utility/PageHeader';
import PageBody from 'utility/PageBody';
import { Button, Form, Input, Row, Col, Table, Modal, Image, Select, Upload, DatePicker, Spin, Card, Divider, Typography, Space, Empty, Radio, message, Tag, TimePicker, Tooltip } from 'antd';
import { HttpHandler } from '../../shared/httpHandler';
import { EditOutlined, DeleteOutlined, RocketOutlined, PlusOutlined, SearchOutlined, UploadOutlined, FontSizeOutlined, FileImageOutlined, MenuOutlined, InteractionOutlined, BorderOutlined, AppstoreOutlined, CopyOutlined, CalendarOutlined, ClockCircleOutlined, ExclamationCircleOutlined, SaveOutlined, ArrowDownOutlined, CheckCircleOutlined, WarningOutlined, SnippetsOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import secureStorage from '../../shared/secureStorage';
import FlexPreview from '../../utility/flex2html';
import { useForm } from 'antd/es/form/Form';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { CryptoHandler } from '../../shared/cryptoHandler';

const httpHandler = new HttpHandler();
const chatbotHandler = new HttpHandler(true, process.env.REACT_APP_TOYOTA_CHATBOT_URL);

const { Text, Title } = Typography;

const sendingTargetOptionsMap = {
    '1': '全體好友',
    '2': '綁定會員',
    '3': '指定 UID',
}

const sendingTypeOptionsMap = {
    "push": "推播訊息",
    "pnp": "通知型訊息",
}

dayjs.locale('zh-tw');
dayjs.extend(utc);
dayjs.extend(timezone);

const formatTime = (value) => {
    // if (!value) return '';
    // return dayjs(value).format('YYYY/M/D A h:mm:ss');
    const time = new Date(value).toLocaleString('zh-TW');
    return time;
};

const BroadcastReview = () => {
    const [msgSearchForm] = Form.useForm();
    const [msgEditForm] = Form.useForm();
    // const [form] = Form.useForm();
    const [msgTableData, setMsgTableData] = useState([]);
    const [msgTableParams, setMsgTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [summayTableData, setSummayTableData] = useState([]);
    const [summaryTableParams, setSummaryTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [loading, setLoading] = useState(false);
    const [currentMsg, setCurrentMsg] = useState({});
    const [selectedMsg, setSelectedMsg] = useState({});
    const [currentEditType, setCurrentEditType] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [apiLoading, setApiLoading] = useState(false);
    const [showUploadExcel, setShowUploadExcel] = useState(false);
    const [excelFileList, setExcelFileList] = useState([]);
    const [isSummaryModalVisible, setIsSummaryModalVisible] = useState(false);
    // 管理目標 User IDs 的狀態
    const [targetUserIds, setTargetUserIds] = useState([]);
    const [imageUploadCount, setImageUploadCount] = useState(0);
    const [isTestReviewModalVisible, setIsTestReviewModalVisible] = useState(false);
    const [summaryQueryForm] = Form.useForm();

    const cryptoHandler = new CryptoHandler();

    const handleTableChange = (pagination, filters, sorter) => {
        setMsgTableParams({
            pagination,
            filters,
            ...sorter,
        });
        getMsgData(pagination);
    };


    const searchMsgData = async () => {
        setMsgTableParams({
            ...msgTableData,
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
        getMsgData({
            current: 1,
            pageSize: 10,
        });
    }

    const getMsgData = async (pagination = msgTableParams.pagination) => {
        let { memo, sendingTime, timeCondition, sendingType, messageName, messageStatus, approvementStatus, sendingResult, content, availableDepts } = msgSearchForm.getFieldsValue();
        memo = memo ? memo : '';
        sendingTime = sendingTime && timeCondition ? `${timeCondition}${dayjs(sendingTime).format("YYYY-MM-DD HH:mm:ss")}` : '';
        sendingType = sendingType ? sendingType : '';
        messageName = messageName ? messageName : '';
        messageStatus = messageStatus ? messageStatus : '0';
        // console.log('messageStatus:', messageStatus);
        approvementStatus = approvementStatus ? approvementStatus : '';
        const createUserDept = secureStorage.getItem('userDepartment') ? secureStorage.getItem('userDepartment') : '未知部門';
        sendingResult = sendingResult ? sendingResult : '';
        // console.log('createUserDept:', createUserDept);
        content = content ? content : '';
        availableDepts = availableDepts ? availableDepts : secureStorage.getItem('userAvailableDepts');

        const { current, pageSize } = pagination;
        // // console.log('sendingTime:', sendingTime);

        setLoading(true);
        httpHandler.get(`/toyota_mgmt/broadcast_maintenance/get_broadcast_msg?msg_name=${messageName}&is_cancel=${messageStatus}&memo=${memo}&is_approved=${approvementStatus}&sending_time=${sendingTime}&create_user_dept=${availableDepts}&sending_result=${sendingResult}&content=${content}&current=${current}&page_size=${pageSize}`)
            .then((response) => {
                if (response.success) {
                    // console.log('raw response:', response);
                    // console.log('response.data:', response.data);
                    setMsgTableData(response.data);
                    setMsgTableParams({
                        ...msgTableData,
                        pagination: {
                            ...pagination,
                            total: response.total,
                        },
                    });
                } else {
                    window.antdNotify('錯誤', response.data.message, 'fail');
                }
                setLoading(false);
            });
    }

    const handleSummaryTableChange = (pagination, filters, sorter) => {
        setSummaryTableParams({
            pagination,
            filters,
            ...sorter,
        });
        getSummaryData(pagination);
    };

    const getSummaryData = async (pagination = summaryTableParams.pagination) => {
        let { endTime, startTime } = summaryQueryForm.getFieldsValue();
        endTime = endTime ? dayjs(endTime).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
        startTime = startTime ? dayjs(startTime).format('YYYY-MM-DD') : dayjs().subtract(1, 'month').format('YYYY-MM-DD');
        const { current, pageSize } = pagination;
        // 檢查發送時間
        if (dayjs(endTime).isBefore(dayjs(startTime))) {
            window.antdNotify('請重新檢查搜尋日期', '結束日期不可早於起始日期', 'fail');
            return;
        }

        setLoading(true);
        httpHandler.get(`/toyota_mgmt/broadcast_maintenance/get_broadcast_msg_summary?user_id=${secureStorage.getItem('userId')}&start_time=${startTime}&end_time=${endTime}&current=${current}&page_size=${pageSize}`).then((response) => {
            if (response.success) {
                // console.log('getSummaryData response.data:', response.data);
                setSummayTableData(response.data.data)
                // console.log('set data to summaryQueryForm')
                // console.log(`start time ${startTime}, end time ${endTime}`)
                summaryQueryForm.setFieldValue('startTime', dayjs(startTime))
                summaryQueryForm.setFieldValue('endTime', dayjs((endTime)))
                setIsSummaryModalVisible(true);
            } else {
                window.antdNotify('獲取推播彙整失敗', response.message, 'fail');
            }
            setLoading(false);
        });
    }

    const MsgSearchBar = () => {
        const deptStr = secureStorage.getItem('userAvailableDepts') || '';
        const deptList = deptStr.split(',').map(s => s.trim()).filter(Boolean);
        return (
            <Form form={msgSearchForm}
                name="msgSearchForm"
                onFinish={searchMsgData}
                initialValues={{ messageStatus: 0, sendingResult: 'review' }}
            >
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item label="訊息名稱" name="messageName">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="訊息內容" name="content">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="備註" name="memo">
                            <Input allowClear />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    {/* <Col span={8}>
                        <Form.Item label="訊息狀態" name="messageStatus">
                            <Select>
                                <Select.Option value={0}>可用訊息</Select.Option>
                                <Select.Option value={1}>已刪除訊息</Select.Option>
                                <Select.Option value={2}>全部訊息</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
                    <Col span={8}>
                        <Form.Item label="審核部門" name="availableDepts" initialValue="">
                            <Select allowClear>
                                <Select.Option value="">全部部門</Select.Option>
                                {deptList.map(dept => (
                                    <Select.Option key={dept} value={dept}>{dept}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    {/* <Col span={8}>
                        <Form.Item label="發送類型" name="sendingType">
                            <Select allowClear>
                                <Select.Option value="push">推播訊息</Select.Option>
                                <Select.Option value="pnp">通知型訊息</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
                    <Col span={8}>
                        <Form.Item label="發送狀態" name="sendingResult">
                            <Select allowClear>
                                <Select.Option value="">全部訊息</Select.Option>
                                <Select.Option value="init">未送審</Select.Option>
                                <Select.Option value="review">等待審核</Select.Option>
                                <Select.Option value="waiting">等待發送</Select.Option>
                                <Select.Option value="canceled">已取消</Select.Option>
                                <Select.Option value="finished">已發送</Select.Option>
                                <Select.Option value="failed">發送失敗</Select.Option>
                                <Select.Option value="rejected">審核未通過</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            label="時間條件"
                            name="timeCondition"
                            dependencies={['sendingTime']}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value && getFieldValue('sendingTime')) {
                                            return Promise.reject(new Error('請選擇時間條件'));
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Select allowClear>
                                <Select.Option value=">">晚於</Select.Option>
                                <Select.Option value="<">早於</Select.Option>
                                <Select.Option value="=">等於</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="發送時間"
                            name="sendingTime"
                            dependencies={['timeCondition']}
                        >
                            <DatePicker showTime allowClear format="YYYY-MM-DD HH:mm" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={16} className="button-group">
                        <Button
                            type="primary"
                            icon={<SnippetsOutlined />}
                            onClick={() => {
                                getSummaryData()
                                setIsSummaryModalVisible(true);
                            }}
                            className="button button--register">
                            推播彙整
                        </Button>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            htmlType="submit"
                            className="button button--search">
                            搜尋
                        </Button>
                    </Col>
                </Row>
            </Form >
        )
    }

    // 上傳前檢查
    const beforeUpload = (file) => {
        // 檢查檔案類型

        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            window.antdNotify('錯誤', '只能上傳圖片檔案', 'fail');
            return Upload.LIST_IGNORE;
        }
        // 檢查檔案大小
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            window.antdNotify('錯誤', '圖片大小不能超過10MB', 'fail');
            return Upload.LIST_IGNORE;
        }
        return false;
    };

    // 上傳圖片轉base64
    const getBase64 = (file) => {
        // console.log('getBase64 file:', file);
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    // 預覽圖片
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewTitle(file.name);
        setPreviewImage(file.preview);
        setPreviewVisible(true);
    };

    const handleRemove = () => {
        setPreviewVisible(false)
        setPreviewImage('')
        setFileList([])
    }

    const handleUploadChange = ({ fileList }) => {
        setFileList(fileList);

        // 檢查文件是否上傳完成
        fileList.forEach(file => {
            handlePreview(file);
        });

        // console.log('fileList after change:', fileList);

    };

    const MsgDataTable = () => {
        const columns = [
            {
                title: '訊息名稱(內部使用)',
                dataIndex: 'msg_name',
                key: 'msg_name',
                fixed: 'left',
            },
            {
                title: '訊息狀態',
                dataIndex: 'sending_result',
                key: 'sending_result',
                fixed: 'left',
                render: (text) => {
                    let color = 'default';
                    let statusText = '';
                    switch (text) {
                        case 'init':
                            color = 'cyan';
                            statusText = '未送審';
                            break;
                        case 'review':
                            color = 'purple';
                            statusText = '等待審核';
                            break;
                        case 'waiting':
                            color = 'blue';
                            statusText = '等待發送';
                            break;
                        case 'canceled':
                            color = 'orange';
                            statusText = '已取消';
                            break;
                        case 'finished':
                            color = 'green';
                            statusText = '已發送';
                            break;
                        case 'failed':
                            color = 'red';
                            statusText = '發送失敗';
                            break;
                        case 'rejected':
                            color = 'volcano';
                            statusText = '審核未通過';
                            break;
                        default:
                            statusText = text;
                    }
                    return <Tag color={color}>{statusText}</Tag>;
                }
            },
            {
                title: '操作',
                key: 'operation',
                render: (text, record) => {
                    // console.log('record in operation column:', record);
                    const isDisabled = (record.is_cancel === 1)
                    const isSettingSendingDisabled = (record.sending_result !== "init")
                    // console.log('isSettingSendingDisabled:', isSettingSendingDisabled);
                    return (
                        <div>
                            <Button
                                type="primary"
                                icon={<EditOutlined />}
                                // disabled={isSettingSendingDisabled}
                                onClick={() => {
                                    setSelectedMsg(record);
                                    setCurrentEditType("編輯推播訊息");
                                    const loadedMsgTableData = convertMessageToTableData(record);
                                    msgEditForm.setFieldsValue({ ...loadedMsgTableData });
                                    setIsModalVisible(true);
                                }}
                                style={{ margin: 4 }}
                            >
                                檢閱訊息
                            </Button>
                            <Button
                                type="primary"
                                icon={<CheckCircleOutlined />}
                                onClick={() => {
                                    // console.log('record to approve:', record);
                                    Modal.confirm({
                                        title: '通過審核',
                                        content: `你確定要通過這筆訊息的審核嗎？`,
                                        okText: '確定',
                                        cancelText: '取消',
                                        onOk() {
                                            httpHandler.post('/toyota_mgmt/broadcast_maintenance/update_msg_approvement', {
                                                id: record.id,
                                                is_approved: 1,
                                                approved_user: secureStorage.getItem('userId'),
                                                reason: record.reason || '',
                                            }).then((response) => {
                                                if (response.success) {
                                                    window.antdNotify('成功', '通過推播訊息審核成功', 'success');
                                                    searchMsgData();
                                                } else {
                                                    window.antdNotify('錯誤', response.message, 'fail');
                                                }
                                            }).finally(() => {
                                                setSelectedMsg({})
                                            });
                                        },
                                    });
                                }}
                                style={{ margin: 4, }}
                                className="button button--register"
                            >
                                審核通過
                            </Button>
                            <Button
                                type="primary"
                                danger
                                icon={<WarningOutlined />}
                                disabled={isDisabled}
                                onClick={() => {
                                    Modal.confirm({
                                        title: '駁回審核',
                                        content: `你確定要駁回這筆訊息的審核嗎？`,
                                        okText: '確定',
                                        cancelText: '取消',
                                        onOk() {
                                            httpHandler.post('/toyota_mgmt/broadcast_maintenance/update_msg_approvement', {
                                                id: record.id,
                                                is_approved: 0,
                                                approved_user: secureStorage.getItem('userId'),
                                                reason: record.reason || '',
                                            }).then((response) => {
                                                if (response.success) {
                                                    window.antdNotify('成功', '駁回推播訊息審核成功', 'success');
                                                    searchMsgData();
                                                } else {
                                                    window.antdNotify('錯誤', response.message, 'fail');
                                                }
                                            }).finally(() => {
                                                setSelectedMsg({})
                                            });
                                        },
                                    });
                                }}
                                style={{ margin: 4 }}
                            >
                                審核駁回
                            </Button>
                        </div>
                    );
                },
            },
            // {
            //     title: '刪除',
            //     key: 'deleteMsg',
            //     render: (text, record) => {
            //         const isDisabled = record.sending_result !== 'waiting'
            //         return (
            //             <Button
            //                 type="primary"
            //                 danger
            //                 icon={<DeleteOutlined />}
            //                 disabled={isDisabled}
            //                 onClick={() => {
            //                     Modal.confirm({
            //                         title: '刪除訊息',
            //                         content: `你確定要刪除這筆訊息嗎？`,
            //                         okText: '確定',
            //                         cancelText: '取消',
            //                         onOk() {
            //                             httpHandler.post('/toyota_mgmt/broadcast_maintenance/cancel_broadcast_msg', {
            //                                 id: record.id,
            //                                 cancel_user: secureStorage.getItem('userName'),
            //                             }).then((response) => {
            //                                 if (response.success) {
            //                                     window.antdNotify('成功', '刪除推播訊息成功', 'success');
            //                                     searchMsgData();
            //                                 } else {
            //                                     window.antdNotify('錯誤', response.message, 'fail');
            //                                 }
            //                             });
            //                         },
            //                     });
            //                 }}
            //             >
            //                 刪除訊息
            //             </Button>
            //         );
            //     },
            // },
            // {
            //     title: "圖片",
            //     dataIndex: 'img',
            //     key: 'img',
            //     render: (text, record) => {
            //         const { img, img_extension } = record;
            //         if (img && img_extension) {
            //             return <img src={`data:image/${img_extension};base64,${img}`} alt="配備圖片" style={{ width: '100px' }} />;
            //         } else {
            //             return '無圖片';
            //         }
            //     },
            // },
            // {
            //     title: '圖片連結/路徑',
            //     dataIndex: 'img_url',
            //     key: 'img_url',
            // },
            // {
            //     title: '標題',
            //     dataIndex: 'title',
            //     key: 'title',
            // },
            // {
            //     title: '內容',
            //     dataIndex: 'content',
            //     key: 'content',
            // },
            // {
            //     title: '連結名稱 1',
            //     dataIndex: 'url1_name',
            //     key: 'url1_name',
            // },
            // {
            //     title: "訊息連結 1",
            //     dataIndex: 'content_url1',
            //     key: 'content_url1',
            // },
            // {
            //     title: '連結名稱 2',
            //     dataIndex: 'url2_name',
            //     key: 'url2_name',
            // },
            // {
            //     title: "訊息連結 2",
            //     dataIndex: 'content_url2',
            //     key: 'content_url2',
            // },
            // {
            //     title: '連結名稱 3',
            //     dataIndex: 'url3_name',
            //     key: 'url3_name',
            // },
            // {
            //     title: "訊息連結 3",
            //     dataIndex: 'content_url3',
            //     key: 'content_url3',
            // },
            // {
            //     title: '發送對象',
            //     dataIndex: 'sending_target',
            //     key: 'sending_target',
            //     render: (text) => {
            //         return sendingTargetOptionsMap[text];
            //     }
            // },
            // {
            //     title: "發送類型",
            //     dataIndex: 'sending_type',
            //     key: 'sending_type',
            //     render: (text) => {
            //         return sendingTypeOptionsMap[text];
            //     }
            // },
            // {
            //     title: '發送時間',
            //     dataIndex: 'sending_time',
            //     key: 'sending_time',
            //     render: (text) => {
            //         return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
            //     }
            // },
            // {
            //     title: "發送結果",
            //     dataIndex: 'sending_result',
            //     key: 'sending_result',
            // },
            // {
            //     title: '發送數量',
            //     dataIndex: 'sending_mount',
            //     key: 'sending_mount',
            // },
            // {
            //     title: '備註',
            //     dataIndex: 'memo',
            //     key: 'memo',
            // },
            {
                title: '建立人員',
                dataIndex: 'create_user_name',
                key: 'create_user_name',
            },
            {
                title: '建立人員部門',
                dataIndex: 'create_user_dept',
                key: 'create_user_dept',
            },
            {
                title: '預估費用(元)',
                dataIndex: 'estimated_cost',
                key: 'estimated_cost',
                render: (text, record) => {
                    const userList = record.sending_target
                        ? record.sending_target.split(',').filter(Boolean)
                        : [];
                    // console.log('userList:', userList);
                    const cost = userList.length * 0.12;
                    return `${cost.toFixed(2)} 元`;
                }
            },
            {
                title: "建立時間",
                dataIndex: 'create_time',
                key: 'create_time',
            },
            {
                title: "最後編輯時間",
                dataIndex: 'update_time',
                key: 'update_time',
                render: (text, record) => {
                    const time = record.update_time || record.create_time;
                    return time
                }
            },
            {
                title: '審核結果',
                dataIndex: 'is_approved',
                key: 'is_approved',
                render: (value) => {
                    return value === 1 ? '已審核' : '未審核';
                }
            },
            {
                title: '審核人員',
                dataIndex: 'approved_user_name',
                key: 'approved_user_name',
            },
            {
                title: "審核時間",
                dataIndex: 'approved_time',
                key: 'approved_time',
                render: (value) => value ? formatTime(value) : '',
            },
            {
                title: '審核意見',
                dataIndex: 'reason',
                key: 'reason',
            },
            {
                title: '預計發送時間',
                dataIndex: 'sending_time',
                key: 'sending_time',
                render: (value) => value ? formatTime(value) : '',
            },
            {
                title: '實際發送時間',
                dataIndex: 'executed_time',
                key: 'executed_time',
                render: (value) => value ? formatTime(value) : '',
            },
            {
                title: '發送數量',
                dataIndex: 'sending_mount',
                key: 'sending_mount',
            },
            {
                title: '發送失敗對象',
                dataIndex: 'failed_user_list',
                key: 'failed_user_list',
            },
            {
                title: '刪除人員',
                dataIndex: 'cancel_user_name',
                key: 'cancel_user_name',
            },
            {
                title: "刪除時間",
                dataIndex: 'cancel_time',
                key: 'cancel_time',
            },
            {
                title: '備註',
                dataIndex: 'memo',
                key: 'memo',
                width: 200,
            }
        ]

        return (
            <div>
                <Table
                    columns={columns}
                    loading={loading}
                    dataSource={msgTableData}
                    pagination={msgTableParams.pagination}
                    scroll={{ x: 'max-content' }}
                    onChange={handleTableChange}
                />
            </div>
        );
    }

    const handleModalOnFinish = () => {
        searchMsgData()
        // setIsModalVisible(false);
        // setSelectedMsg({});
        // setCurrentEditType("");
        // setPreviewImage('');
        // setPreviewTitle('');
        // setPreviewVisible(false);
        // setFileList([]);
        // msgEditForm.resetFields();
    }

    const handleEditModalOnCancel = () => {
        setIsModalVisible(false);
        setSelectedMsg({});
        setCurrentEditType("");
        setPreviewImage('');
        setPreviewTitle('');
        setPreviewVisible(false);
        setFileList([]);
        msgEditForm.resetFields();
    }

    // const setSelectedMsgFieldsValue = (record) => {
    //     msgEditForm.setFieldsValue({
    //         title: record.title,
    //         content: record.content,
    //         content_url1: record.content_url1,
    //         content_url2: record.content_url2,
    //         content_url3: record.content_url3,
    //         img: record.img,
    //         memo: record.memo,
    //         sendingTarget: record.sending_target,
    //         sendingType: record.sending_type,
    //         sendingTime: dayjs(record.sending_time),
    //     });
    // }



    const editModalSubmitHandler = async ({ form, finalJson }) => {
        setApiLoading(true);
        // // console.log('apiLoading', apiLoading);

        const submitData = form.getFieldsValue();

        // console.log('submit_submitData:', submitData);


        if (currentEditType === "新增推播訊息" || currentEditType === "建立訊息副本") {

            let binaryData = "";
            let extension = "";

            if (fileList && fileList.length > 0) {
                try {
                    binaryData = await getBase64(submitData.img.fileList[0].originFileObj);
                    extension = submitData.img.fileList[0].name.split('.').pop();
                } catch (error) {
                    console.error('Error reading file:', error);
                }
            }

            // if (submitData.sending_target === 3 && !excelFileList) {
            //     window.antdNotify('錯誤', '請上傳 UID Excel 檔案', 'fail');
            //     setApiLoading(false);
            //     return;
            // }

            let excelBinaryData = "";
            let excelExtension = "";
            if (excelFileList && excelFileList.length > 0) {
                try {
                    excelBinaryData = await getBase64(excelFileList[0].originFileObj);
                    excelExtension = excelFileList[0].name.split('.').pop();
                } catch (error) {
                    console.error('Error reading file:', error);
                }
            }

            // console.log('submitData', submitData);

            const postData = {
                msg_name: submitData.messageName,
                create_user: secureStorage.getItem('userId'),
                memo: submitData.memo || '',
                sending_result: 'init',
                create_user_dept: secureStorage.getItem('userDepartment'),
                is_approved: 0,
                is_cancel: 0,
                message_json: cryptoHandler.encryptHex(JSON.stringify(finalJson)) || '',
            };

            // console.log('postData:', postData);
            httpHandler.post('/toyota_mgmt/broadcast_maintenance/insert_broadcast_msg', postData).then((response) => {
                if (response.success) {
                    window.antdNotify('成功', '新增推播訊息成功', 'success');
                    handleModalOnFinish();
                } else {
                    window.antdNotify('錯誤', response.message, 'fail');
                }
            }).finally(() => {
                setApiLoading(false);
            });
        } else if (currentEditType === "編輯推播訊息") {
            // // console.log(`fileList: ${fileList}`);
            // // console.log('submitData:', submitData);

            let binaryData = "";
            let extension = "";

            if (fileList && fileList.length > 0) {
                if (submitData.img && submitData.img.fileList.length > 0) {
                    try {
                        binaryData = await getBase64(submitData.img.fileList[0].originFileObj);
                        extension = submitData.img.fileList[0].name.split('.').pop();
                    } catch (error) {
                        console.error('Error reading file:', error);
                    }
                }
            }

            // if (submitData.sending_target === 3 && !excelFileList) {
            //     window.antdNotify('錯誤', '請上傳 UID Excel 檔案', 'fail');
            //     setApiLoading(false);
            //     return;
            // }

            // console.log('excelFileList in update:', excelFileList);

            let excelBinaryData = "";
            let excelExtension = "";
            let excelFile = null;
            if (excelFileList && excelFileList.length > 0) {
                try {
                    excelBinaryData = await getBase64(excelFileList[0].originFileObj);
                    excelExtension = excelFileList[0].name.split('.').pop();
                    excelFile = excelFileList[0].originFileObj;
                } catch (error) {
                    console.error('Error reading file:', error);
                }
            }

            // console.log('final_json in update', finalJson);

            console.log(`reason ${submitData.reason}`)


            const postData = {
                id: selectedMsg.id,
                msg_name: submitData.messageName || '',
                // msg_type: submitData.msg_type || 0,
                // title1: submitData.title1 || '',
                // title2: submitData.title2 || '',
                // title3: submitData.title3 || '',
                // title4: submitData.title4 || '',
                // title5: submitData.title5 || '',
                // content1: submitData.content1 || '',
                // content2: submitData.content2 || '',
                // content3: submitData.content3 || '',
                // content4: submitData.content4 || '',
                // content5: submitData.content5 || '',
                // img1: submitData.img1 || null,
                // img2: submitData.img2 || null,
                // img3: submitData.img3 || null,
                // img4: submitData.img4 || null,
                // img5: submitData.img5 || null,
                // img_extension1: submitData.img_extension1 || '',
                // img_extension2: submitData.img_extension2 || '',
                // img_extension3: submitData.img_extension3 || '',
                // img_extension4: submitData.img_extension4 || '',
                // img_extension5: submitData.img_extension5 || '',
                // img_url1: submitData.img_url1 || '',
                // img_url2: submitData.img_url2 || '',
                // img_url3: submitData.img_url3 || '',
                // img_url4: submitData.img_url4 || '',
                // img_url5: submitData.img_url5 || '',
                // sending_target: submitData.sending_target || '',
                sending_time: submitData.sendingTime ? dayjs(submitData.sendingTime).tz('Asia/Taipei').format('YYYY-MM-DDTHH:mm:ssZ') : null,
                memo: submitData.memo || '',
                // sending_type: submitData.sending_type || '',
                // sending_result: submitData.sending_result || '',
                // button_content1: submitData.button_content1 || '',
                // button_content2: submitData.button_content2 || '',
                // button_content3: submitData.button_content3 || '',
                // button_content4: submitData.button_content4 || '',
                // button_content5: submitData.button_content5 || '',
                // button_name1: submitData.button_name1 || '',
                // button_name2: submitData.button_name2 || '',
                // button_name3: submitData.button_name3 || '',
                // button_name4: submitData.button_name4 || '',
                // button_name5: submitData.button_name5 || '',
                update_user: secureStorage.getItem('userId') || null,
                // update_time: moment().format('YYYY-MM-DD HH:mm:ss'),
                // create_user_dept: submitData.create_user_dept || '',
                // sending_mount: submitData.sending_mount || null,
                // local_user_list: submitData.local_user_list || '',
                // is_approved: submitData.is_approved || null,
                // is_cancel: submitData.is_cancel || null,
                // approved_user: submitData.approved_user || null,
                // approved_time: submitData.approved_time || null,
                reason: submitData.reason || '',
                // cancel_user: submitData.cancel_user || null,
                // cancel_time: submitData.cancel_time || null,
                // excel_file: submitData.excel_file || null,
                // button_content6: submitData.button_content6 || '',
                // button_name6: submitData.button_name6 || '',
                // img6: submitData.img6 || null,
                // img7: submitData.img7 || null,
                // img8: submitData.img8 || null,
                // img9: submitData.img9 || null,
                // img_extension6: submitData.img_extension6 || '',
                // img_extension7: submitData.img_extension7 || '',
                // img_extension8: submitData.img_extension8 || '',
                // img_extension9: submitData.img_extension9 || '',
                // img_url6: submitData.img_url6 || '',
                // img_url7: submitData.img_url7 || '',
                // img_url8: submitData.img_url8 || '',
                // img_url9: submitData.img_url9 || '',
                // url1: submitData.url1 || '',
                // url2: submitData.url2 || '',
                // url3: submitData.url3 || '',
                // url4: submitData.url4 || '',
                // url5: submitData.url5 || '',
                // url6: submitData.url6 || '',
                // url7: submitData.url7 || '',
                // url8: submitData.url8 || '',
                // url9: submitData.url9 || '',
                altText: submitData.altText || '',
                // message_json: JSON.stringify(finalJson) || '',
                message_json: cryptoHandler.encryptHex(JSON.stringify(finalJson)) || '',
                excel_file: excelBinaryData,
            };

            console.log(`sending_time : ${dayjs(submitData.sendingTime).tz('Asia/Taipei')}`)

            const formData = new FormData();
            formData.append('id', selectedMsg.id);
            formData.append('msg_name', submitData.messageName || '');
            formData.append('sending_time', submitData.sendingTime ? dayjs(submitData.sendingTime).tz('Asia/Taipei').format('YYYY-MM-DDTHH:mm:ssZ') : null)
            formData.append('memo', submitData.memo || '');
            formData.append('update_user', secureStorage.getItem('userId') || '');
            formData.append('altText', submitData.altText || '');
            formData.append('reason', submitData.reason || '',)
            formData.append('message_json', cryptoHandler.encryptHex(JSON.stringify(finalJson)) || '');
            if (excelFile) {
                formData.append('excel_file', excelFile, `excel.${excelExtension}`);
            }



            console.log('postData:', postData);
            httpHandler.post(
                '/toyota_mgmt/broadcast_maintenance/update_broadcast_msg_formdata',
                formData,
                null
            ).then((response) => {
                if (response.success) {
                    window.antdNotify('成功', '編輯推播訊息成功', 'success');
                    handleModalOnFinish();
                } else {
                    // window.antdNotify('錯誤', response.message, 'fail');
                    // // console.log('postData:', postData);
                    httpHandler.post('/toyota_mgmt/broadcast_maintenance/update_broadcast_msg', postData).then((response) => {
                        // console.log('postData:', postData);
                        if (response.success) {
                            window.antdNotify('成功', '編輯推播訊息成功', 'success');
                            handleModalOnFinish();
                        } else {
                            window.antdNotify('錯誤', response.message, 'fail');
                        }
                    })
                }
            })
        }
        setApiLoading(false);

    }

    // 轉換已存的訊息資料為編輯器格式
    function convertMessageToTableData(selectedMsg) {
        // console.log('convertMessageToTableData_selectedMsg', selectedMsg);
        const tableData = {
            messageName: selectedMsg.msg_name || '',
            altText: selectedMsg.altText || '',
            memo: selectedMsg.memo || '',
            reason: selectedMsg.reason || '',
            sendingTime: selectedMsg.sending_time ? dayjs(selectedMsg.sending_time) : null,
            sendingCount: selectedMsg.sending_target ? selectedMsg.sending_target.split(',').filter(Boolean).length : 0,
            layout: 'bubble', // 預設為 bubble
            bubbles: []
        };

        const message = selectedMsg.message_json ? JSON.parse(cryptoHandler.decryptHex(selectedMsg.message_json)) : selectedMsg.message_json;

        if (!message || message.type !== "flex") {
            console.warn("Input message is not a valid Flex Message object.");
            // 如果無效，返回一個包含單個空 bubble 的結構作為預設值
            tableData.bubbles = [{ items: [] }];
            return tableData;
        }

        const contents = message.contents;

        if (!contents) {
            tableData.bubbles = [{ items: [] }];
            return tableData;
        }


        /**
         * Helper 函式：將單個 Bubble JSON 轉換為編輯器所需的 Bubble 結構
         * @param {object} bubbleJson - 單個 'bubble' 類型的內容
         * @returns {object} 編輯器用的 Bubble 物件
         */
        const convertSingleBubble = (bubbleJson) => {
            const editorBubble = {
                heroImageUrl: '',
                items: []
            };

            // 1. 處理 Hero 區塊 (主圖)
            // console.log('processing bubbleJson for hero:', bubbleJson);
            if (bubbleJson.hero && bubbleJson.hero.type === 'image') {
                // console.log('Processing hero image:', bubbleJson.hero);
                editorBubble.heroImageUrl = bubbleJson.hero.url || '';
                editorBubble.heroAction = bubbleJson.hero?.action?.type || null;
                // console.log('Initial heroAction:', editorBubble.heroAction);
                if (editorBubble.heroAction) {
                    if (bubbleJson.hero.action.type === 'uri') {
                        let data = bubbleJson.hero.action.uri || '';
                        if (data.startsWith('tel:')) {
                            data = data.slice(4);
                            editorBubble.heroAction = 'tel';
                            editorBubble.heroUri = data;
                        } else if (data.startsWith('mailto:')) {
                            data = data.slice(7);
                            editorBubble.heroAction = 'email';
                            editorBubble.heroUri = data;
                        } else {
                            editorBubble.heroAction = 'uri';
                            editorBubble.heroUri = data;
                        }
                    } else if (bubbleJson.hero.action.type === 'message') {
                        editorBubble.heroAction = 'message'
                        editorBubble.heroUri = bubbleJson.hero.action.text || '';
                    }
                } else {
                    editorBubble.heroAction = 'none';
                }


                editorBubble.heroAspectRatio = bubbleJson.hero.aspectRatio || '20:13';
            }

            // 2. 處理 Body 區塊 (內容元素)
            const bodyContents = bubbleJson.body?.contents || [];
            // console.log('processing bodyContents:', bodyContents);

            editorBubble.items = bodyContents.map(item => {
                const editorItem = { type: item.type };

                if (item.type === 'text') {
                    // 處理 Text 元素
                    editorItem.content = item.text || '';
                    editorItem.size = item.size || 'md';
                    editorItem.weight = item.weight || 'regular';
                    editorItem.color = item.color || '#000000';
                    // 忽略 wrap 屬性，因為編輯器預設為 true
                } else if (item.type === 'image') {
                    // 處理 Image 元素
                    editorItem.url = item.url || '';
                    editorItem.size = item.size || 'full';
                    editorItem.aspectRatio = item.aspectRatio || '1.91:1';
                    editorItem.aspectMode = item.aspectMode || 'cover';
                } else if (item.type === 'button') {
                    // 處理 Button 元素
                    editorItem.label = item.action?.label || '按鈕';
                    editorItem.action = item.action?.type || 'uri'; // 我們假設 action type 是 uri 或 message
                    if (item.action?.type === 'uri') {
                        let uri = item.action.uri || '';
                        if (uri.startsWith('tel:')) {
                            uri = uri.slice(4);
                            editorItem.action = 'tel';
                        } else if (uri.startsWith('mailto:')) {
                            uri = uri.slice(7);
                            editorItem.action = 'email';
                        }
                        editorItem.uri = uri || '';
                    } else if (item.action?.type === 'message') {
                        editorItem.uri = item.action.text || '';
                    } else {
                        editorItem.uri = '';
                    }
                    // editorItem.uri = item.action.uri || ''; // 我們假設 action type 是 uri
                    // 處理 style 問題
                    if (item?.color === '#E60020') {
                        editorItem.style = 'danger'
                    } else {
                        editorItem.style = item.style || 'link';
                    }
                    // 忽略 height 屬性
                }
                // 忽略 box 類型或其他未在編輯器中實作的類型

                return editorItem;
            });

            // console.log('convertSingleBubble', editorBubble);

            return editorBubble;
        };

        // console.log('Flex Message contents to process:', contents);

        // 根據 contents 的類型決定如何解析
        if (contents.type === 'bubble') {
            // 1. 單一圖卡 (Bubble) 模式
            tableData.layout = 'bubble';
            tableData.bubbles.push(convertSingleBubble(contents));
            // console.log('Processed single bubble:', tableData.bubbles[0]);
        } else if (contents.type === 'carousel') {
            // 2. 輪播圖卡 (Carousel) 模式
            tableData.layout = 'carousel';

            // 遍歷 contents 陣列中的每個 bubble
            if (Array.isArray(contents.contents)) {
                contents.contents.forEach(bubbleJson => {
                    if (bubbleJson.type === 'bubble') {
                        tableData.bubbles.push(convertSingleBubble(bubbleJson));
                    }
                });
            }
            // console.log('Processed carousel bubbles:', tableData.bubbles);
        } else {
            // 如果內容類型未知，給予預設值
            console.warn("Flex Message contents type is neither 'bubble' nor 'carousel'.");
            tableData.bubbles = [{ items: [] }];
            return tableData;
        }

        // 確保即使內容解析失敗，至少有一個空的 bubble 結構
        if (tableData.bubbles.length === 0) {
            tableData.bubbles.push({ items: [] });
        }

        // console.log('convertMessageToTableData1', tableData);

        return tableData;
    }



    const EditModal = ({ form }) => {
        // const [form] = Form.useForm();
        const [previewJson, setPreviewJson] = useState({});

        // 監聽表單變動
        const formValues = Form.useWatch([], form);
        const layoutMode = Form.useWatch('layout', form); // 監聽目前的佈局模式

        useEffect(() => {
            if (formValues) {
                // console.log('formValues changed:', formValues);
                const json = generateFlexMessage(formValues);
                // console.log('Generated JSON for preview:', json);
                setPreviewJson(json);
            }
        }, [formValues]);


        // 產生單一 Bubble 的 JSON 結構
        const createBubble = (bubbleData) => {
            if (!bubbleData) return null;

            // console.log('createBubble_input:', bubbleData);

            // 建立 Body 內容
            const bodyContents = (bubbleData.items || []).map(item => {
                if (item.type === 'text') {
                    return {
                        type: "text",
                        text: item.content || " ",
                        size: item.size || "md",
                        color: item.color || "#000000",
                        weight: item.weight || "regular",
                        wrap: true
                    };
                } else if (item.type === 'image') {
                    return {
                        type: "image",
                        url: item.url || "https://via.placeholder.com/300",
                        size: item.size || "full",
                        aspectRatio: item.aspectRatio || "1.91:1",
                        aspectMode: item.aspectMode || "cover"
                    };
                } else if (item.type === 'button') {
                    // console.log('Processing button item:', item);
                    // let button = {
                    //     type: "button",
                    //     style: item.style || "link",
                    //     height: "sm",
                    //     // action: {
                    //     //     type: "uri",
                    //     //     label: item.label || "按鈕",
                    //     //     uri: item.uri || "http://line.me"
                    //     // }
                    // };
                    // 紅底色按鈕用 danger 作為分別 但是這裡要改回 primary 因為 line 不允許 danger
                    let button = {}
                    if (item.style === 'danger') {
                        button = {
                            type: "button",
                            style: 'primary',
                            height: "sm",
                            color: '#E60020',
                            // action: {
                            //     type: "uri",
                            //     label: item.label || "按鈕",
                            //     uri: item.uri || "http://line.me"
                            // }
                        };
                    } else {
                        button = {
                            type: "button",
                            style: item.style || "link",
                            height: "sm",
                            // action: {
                            //     type: "uri",
                            //     label: item.label || "按鈕",
                            //     uri: item.uri || "http://line.me"
                            // }
                        };
                    }
                    if (item.action === 'uri' && item.uri) {
                        button.action = {
                            type: "uri",
                            label: item.label || "按鈕",
                            uri: item.uri
                        };
                    } else if (item.action === 'message' && item.uri) {
                        button.action = {
                            type: "message",
                            label: item.label || "按鈕",
                            text: item.uri
                        };
                    } else if (item.action === 'tel' && item.uri) {
                        // const phoneValify = /^tel:\+?\d{5,15}$/.test(`tel:${item.uri}`);
                        // if (!phoneValify) {
                        //     window.antdNotify('錯誤', '請輸入正確的電話號碼格式', 'fail');
                        // }

                        button.action = {
                            type: "uri",
                            label: item.label || "按鈕",
                            uri: `tel:${item.uri.replace(/\s+/g, '')}`
                        };
                    } else if (item.action === 'email' && item.uri) {
                        button.action = {
                            type: "uri",
                            label: item.label || "按鈕",
                            uri: `mailto:${item.uri}`
                        };
                    } else {
                        button.action = {
                            type: "uri",
                            label: item.label || "按鈕",
                            uri: item.uri || 'https://www.toyota.com.tw/'
                        };
                    }
                    return button;
                    // return {
                    //     type: "button",
                    //     style: item.style || "link",
                    //     height: "sm",
                    //     action: {
                    //         type: "uri",
                    //         label: item.label || "按鈕",
                    //         uri: item.uri || "http://line.me"
                    //     }
                    // };
                }
            }).filter(item => item !== null);

            // 建立 Hero 區塊
            const heroBlock = bubbleData.heroImageUrl ? {
                type: "image",
                url: bubbleData.heroImageUrl,
                size: "full",
                // aspectRatio: "20:13",
                aspectRatio: bubbleData.heroAspectRatio || "20:13",
                aspectMode: "cover",
            } : undefined;

            if (bubbleData.heroImageUrl && bubbleData.heroAction === 'uri' && bubbleData.heroUri) {
                heroBlock.action = {
                    type: "uri",
                    label: bubbleData.label || "按鈕",
                    uri: bubbleData.heroUri
                };
            } else if (bubbleData.heroImageUrl && bubbleData.heroAction === 'message' && bubbleData.heroUri) {
                heroBlock.action = {
                    type: "message",
                    label: bubbleData.label || "按鈕",
                    text: bubbleData.heroUri
                };
            } else if (bubbleData.heroImageUrl && bubbleData.heroAction === 'tel' && bubbleData.heroUri) {
                // const phoneValify = /^tel:\+?\d{5,15}$/.test(`tel:${bubbleData.heroUri}`);
                // if (!phoneValify) {
                //     window.antdNotify('錯誤', '請輸入正確的電話號碼格式', 'fail');
                // }
                heroBlock.action = {
                    type: "uri",
                    label: bubbleData.label || "按鈕",
                    uri: `tel:${bubbleData.heroUri.replace(/\s+/g, '')}`
                };
            } else if (bubbleData.heroImageUrl && bubbleData.heroAction === 'email' && bubbleData.heroUri) {
                heroBlock.action = {
                    type: "uri",
                    label: bubbleData.label || "按鈕",
                    uri: `mailto:${bubbleData.heroUri}`
                };
            }

            let final_body = {
                type: "bubble",
                size: "mega",
                hero: heroBlock,
            };

            if (bodyContents.length > 0) {
                final_body.body = {
                    type: "box",
                    layout: "vertical",
                    contents: bodyContents,
                    spacing: '10px'
                };
            }

            // console.log('createBubble_output:', final_body);

            return final_body;

            // return {
            //     type: "bubble",
            //     size: "mega",
            //     hero: heroBlock,
            //     // body: {
            //     //     type: "box",
            //     //     layout: "vertical",
            //     //     contents: bodyContents.length > 0 ? bodyContents : [
            //     //         {
            //     //             type: "text",
            //     //             text: "請新增元素以編輯內容",
            //     //             color: "#aaaaaa",
            //     //             align: "center"
            //     //         }
            //     //     ]
            //     // }
            //     // body: bodyContents.length > 0 ? {
            //     //     type: "box",
            //     //     layout: "vertical",
            //     //     contents: bodyContents,
            //     //     spacing: '10px'
            //     // } : {}
            // };
        };

        // 產生完整的 Flex Message JSON
        const generateFlexMessage = (data) => {
            if (!data || !data.bubbles) return {};

            let contents;

            if (data.layout === 'carousel') {
                // 輪播模式
                const bubbles = data.bubbles.map(b => createBubble(b)).filter(b => b !== null);
                contents = {
                    type: "carousel",
                    contents: bubbles
                };
            } else {
                // 單一圖卡模式 (只取第一個 bubble)
                contents = createBubble(data.bubbles[0]);
            }

            return {
                type: "flex",
                altText: data.altText || "Flex Message",
                contents: contents
            };
        };

        const handleOk = () => {
            form.validateFields().then(values => {
                const finalJson = generateFlexMessage(values);
                let contentText = '確定要儲存目前的設定嗎？';
                if (currentEditType === '新增推播訊息') {
                    contentText = '確定新增當前推播訊息嗎？';
                } else if (currentEditType === '編輯推播訊息') {
                    contentText = '確定更新當前推播訊息嗎？';
                } else if (currentEditType === '建立訊息副本') {
                    contentText = '確定儲存當前訊息副本嗎？';
                }
                Modal.confirm({
                    title: '確認執行',
                    content: contentText,
                    onOk: () => {
                        // console.log('Final JSON:', finalJson);
                        // console.log('Form Values:', values);
                        setIsModalVisible(false);
                        editModalSubmitHandler({ form, finalJson });
                        message.success('儲存成功！');
                    }
                });
            }).catch(info => {
                // console.log('Validate Failed:', info);
            });
        };

        const uploadImageToBackend = async (file) => {
            let imgData = "";
            let extension = "";
            try {
                const formData = new FormData();
                formData.append('image', file);
                const response = await chatbotHandler.post('/broadcast_maintenance/upload_msg_pic_formdata', formData, null);
                // console.log('uploadImageToBackend_response:', response);
                if (response.success) {
                    return response.data.img_url; // 假設後端返回的圖片網址字段為 image_url
                } else {
                    throw new Error('FormData 圖片上傳失敗, 重新嘗試中...');
                }
            } catch (err) {
                try {
                    imgData = await getBase64(file);
                    extension = file.name.split('.').pop();
                    const response2 = await chatbotHandler.post('/broadcast_maintenance/upload_msg_pic', {
                        img: imgData,
                        img_extension: extension,
                    });
                    if (response2.success) {
                        return response2.data.img_url;
                    }
                    throw new Error('base64 圖片上傳失敗');
                } catch (err2) {
                    console.error("Upload failed (FormData)", err2);
                    throw err2;
                }
            }
        }

        const ImageUploadInput = ({ value, onChange, placeholder }) => {
            const [loading, setLoading] = useState(false);

            const handleUpload = async (file) => {
                if (file.size > 10 * 1024 * 1024) {
                    message.error('圖片大小不能超過 10MB');
                    return false;
                }
                setLoading(true);
                try {
                    const imageUrl = await uploadImageToBackend(file);
                    // const imageUrl = 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/01_1_cafe.png'
                    // console.log('Uploaded image URL:', imageUrl);
                    onChange(imageUrl); // 更新 Form 的值
                    message.success('圖片上傳成功');
                } catch (error) {
                    message.error('圖片上傳失敗');
                } finally {
                    setLoading(false);
                }
                return false; // 阻止 antd 預設上傳行為
            };

            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Input.Group compact style={{ display: 'flex', paddingRight: '20px', flex: 2 }}>
                        <Input
                            style={{ width: 'calc(100% - 40px)', flex: 3, }}
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            placeholder={"請輸入圖片網址或點擊右側按鈕上傳圖片"}
                        />
                        <Upload
                            accept="image/*"
                            showUploadList={false}
                            beforeUpload={handleUpload}
                            style={{ flex: 1 }}
                        >
                            <Tooltip title="上傳圖片">
                                <Button
                                    icon={loading ? <Spin size="small" /> : <UploadOutlined />}
                                    disabled={loading}
                                >上傳圖片</Button>
                            </Tooltip>
                        </Upload>
                    </Input.Group>
                    <Text type="secondary" style={{ fontSize: '12px', flex: 1 }}>
                        <ExclamationCircleOutlined style={{ marginRight: '4px' }} />檔案大小需小於 10 MB

                    </Text>
                </div >
            );
        };

        // 渲染單個內容元素的編輯器 (文字/圖片/按鈕)
        const renderContentItemEditor = (field, remove, type) => (
            <Card
                key={field.key}
                size="small"
                title={
                    <Space>
                        <MenuOutlined style={{ color: '#999' }} />
                        <Text strong style={{ fontSize: '13px' }}>
                            {type === 'text' ? '文字' : type === 'image' ? '圖片' : '按鈕'}
                        </Text>
                    </Space>
                }
                extra={
                    <Button
                        type="text"
                        danger
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => remove(field.name)}
                    />
                }
                style={{
                    marginBottom: '10px',
                    borderColor: type === 'text' ? '#69c0ff' : type === 'image' ? '#95de64' : '#ff9c6e',
                    borderLeftWidth: '4px',
                }}
                bodyStyle={{ padding: '12px' }}
            >
                <Form.Item name={[field.name, 'type']} hidden><Input /></Form.Item>

                {type === 'text' && (
                    <>
                        <Form.Item name={[field.name, 'content']} noStyle>
                            <Input.TextArea placeholder="輸入文字..." autoSize={{ minRows: 4 }} style={{ marginBottom: 24 }} maxLength={500} showCount />
                        </Form.Item>
                        <Row gutter={8}>
                            <Col span={8}>
                                <Form.Item name={[field.name, 'size']} initialValue="md" label="字體大小">
                                    <Select size="small" style={{ width: '100%' }} placeholder="大小">
                                        <Select.Option value="sm">小</Select.Option>
                                        <Select.Option value="md">中</Select.Option>
                                        <Select.Option value="lg">大</Select.Option>
                                        <Select.Option value="xl">特大</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={[field.name, 'weight']} initialValue="regular" label="字體粗細">
                                    <Select size="small" style={{ width: '100%' }} placeholder="粗細">
                                        <Select.Option value="regular">一般</Select.Option>
                                        <Select.Option value="bold">粗體</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name={[field.name, 'color']} initialValue="#000000" label="字體顏色">
                                    <Input type="color" size="small" style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}

                {type === 'image' && (
                    <>
                        <Form.Item name={[field.name, 'url']} style={{ marginBottom: 8 }}>
                            {/* <Input size="small" placeholder="圖片網址 https://..." /> */}
                            <ImageUploadInput placeholder="圖片網址" />
                        </Form.Item>
                        <Row gutter={8}>
                            <Col span={12}>
                                <Form.Item label="比例" name={[field.name, 'aspectRatio']} initialValue="1.91:1" style={{ marginBottom: 0 }}>
                                    <Select size="small">
                                        <Select.Option value="1:1">1:1</Select.Option>
                                        <Select.Option value="1.91:1">1.91:1</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="模式" name={[field.name, 'aspectMode']} initialValue="cover" style={{ marginBottom: 0 }}>
                                    <Select size="small">
                                        <Select.Option value="cover">填滿</Select.Option>
                                        <Select.Option value="fit">完整</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}

                {type === 'button' && (
                    <>
                        <Row gutter={8} style={{ marginBottom: 8 }}>
                            <Col span={12}>
                                <Form.Item name={[field.name, 'label']} label="按鈕文字">
                                    <Input size="small" placeholder="按鈕文字" maxLength={40} showCount />
                                </Form.Item></Col>
                            <Col span={12}>
                                <Form.Item name={[field.name, 'style']} initialValue="link" label="按鈕樣式">
                                    <Select size="small" style={{ width: '100%' }}>
                                        <Select.Option value="link">無底色</Select.Option>
                                        <Select.Option value="primary">綠底色</Select.Option>
                                        <Select.Option value="danger" color="#E60020">紅底色</Select.Option>
                                        <Select.Option value="secondary">灰底色</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8} style={{ marginBottom: 8 }}>
                            <Col span={12}>
                                <Form.Item label="按鈕動作" name={[field.name, 'action']} initialValue="uri">
                                    <Select size="small" style={{ width: '100%' }}>
                                        <Select.Option value="uri">連結轉跳</Select.Option>
                                        <Select.Option value="message">於聊天室回傳訊息</Select.Option>
                                        <Select.Option value="tel">撥打電話</Select.Option>
                                        <Select.Option value="email">傳送電子郵件</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name={[field.name, 'uri']} style={{ marginBottom: 0 }} label='按鈕連結/訊息/電話/電子郵件'>
                                    <Input size="small" placeholder="請輸入 按鈕連結 / 訊息 / 電話 / 電子郵件" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}
            </Card>
        );

        let okText = '儲存變更';
        if (currentEditType === '新增推播訊息') {
            okText = '新增訊息';
        } else if (currentEditType === '建立訊息副本') {
            okText = '建立副本';
        } else if (currentEditType === '編輯推播訊息') {
            okText = '儲存變更';
        }

        return (
            <Modal
                width="90%"
                style={{ top: 20 }}
                title={<Space><InteractionOutlined /><span style={{ fontWeight: 'bold' }}>Flex Message 編輯器</span></Space>}
                // visible={isModalVisible}
                visible={isModalVisible}
                onCancel={() => {
                    Modal.confirm({
                        title: '確認取消',
                        content: '確定要取消編輯訊息嗎？未儲存的變更將會遺失。',
                        okText: '確定',
                        cancelText: '返回',
                        onOk: () => {
                            handleEditModalOnCancel();
                        },
                    });
                }}
                onOk={handleOk}
                okText={okText}
                cancelText="取消"
                bodyStyle={{ height: '75vh', padding: 0, overflow: 'hidden' }
                }
            >
                <div style={{ display: 'flex', height: '100%' }}>

                    {/* --- 左側編輯區 --- */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '20px', background: '#f5f7fa', borderRight: '1px solid #e8e8e8' }}>
                        <Form
                            form={form}
                            layout="vertical"
                            initialValues={{
                                layout: 'bubble', // 預設單一圖卡
                                bubbles: [{ items: [{ type: 'text', content: '歡迎使用' }] }] // 預設一個 Bubble
                            }}
                        >
                            {/* 1. 全域設定區 */}
                            <Card size="small" style={{ marginBottom: 20, borderRadius: 8, borderTop: '3px solid #1890ff', paddingLeft: '10px', paddingRight: '10px' }}>
                                <Row gutter={16}>
                                    <Col span={6}>
                                        <Form.Item label="佈局模式" name="layout" style={{ marginBottom: 12 }}>
                                            <Radio.Group buttonStyle="solid">
                                                <Radio.Button value="bubble"><BorderOutlined /> 單一圖卡</Radio.Button>
                                                <Radio.Button value="carousel"><AppstoreOutlined /> 輪播圖卡</Radio.Button>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Col>
                                    {/* <Col span={6}>
                                        <Form.Item label="發送類型" name="messageType" style={{ marginBottom: 12 }}>
                                            <Radio.Group buttonStyle="solid">
                                                <Radio.Button value="push"><BorderOutlined /> Push</Radio.Button>
                                                <Radio.Button value="pnp"><AppstoreOutlined /> PNP</Radio.Button>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Col> */}
                                    <Col span={9}>
                                        <Form.Item label="訊息名稱" name="messageName" rules={[{ required: true, message: '請輸入訊息名稱' }]}>
                                            <Input placeholder="請輸入訊息名稱..." prefix={<FileImageOutlined style={{ color: '#bfbfbf' }} />} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={9}>
                                        <Form.Item label="聊天列表預覽文字" name="altText" rules={[{ required: true }]} style={{ marginBottom: 12 }}>
                                            <Input placeholder="聊天列表中顯示的預覽文字" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label="訊息備註" name="memo">
                                            <Input.TextArea placeholder="可自由輸入此訊息備註/說明/用途，僅供管理後台使用" autoSize={{ minRows: 2 }} maxLength={100} showCount />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Form.Item label="預計發送時間" name="sendingTime" style={{ marginBottom: 12 }}>
                                            <DatePicker showTime style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="發送人數" name="sendingCount" style={{ marginBottom: 12 }}>
                                            <Input placeholder="發送人數" disabled />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Divider style={{ margin: '10px 0' }} />
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label={<Text strong>審核意見 (選填)</Text>} name="reason">
                                            <Input.TextArea placeholder="輸入此訊息審核相關意見或駁回理由" autoSize={{ minRows: 4 }} maxLength={100} showCount />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>

                            {/* 2. Bubble 列表區 (核心) */}
                            <Form.List name="bubbles">
                                {(bubbleFields, { add: addBubble, remove: removeBubble }) => (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                                        {bubbleFields.map((bubbleField, index) => {
                                            // console.log('Form.List bubbleField in map', bubbleField);
                                            // console.log('Form.List index in map', index);
                                            // 如果是單一模式，只顯示第一個 Bubble
                                            if (layoutMode === 'bubble' && index > 0) return null;

                                            return (
                                                <Card
                                                    key={bubbleField.key}
                                                    type="inner"
                                                    title={layoutMode === 'carousel' ? `圖卡 #${index + 1}` : "圖卡內容編輯"}
                                                    extra={layoutMode === 'carousel' && bubbleFields.length > 1 && (
                                                        <Button danger type="text" icon={<DeleteOutlined />} onClick={() => removeBubble(bubbleField.name)}>刪除圖卡</Button>
                                                    )}
                                                    style={{ background: '#fff', borderColor: '#d9d9d9' }}
                                                    headStyle={{ background: '#fafafa' }}
                                                >
                                                    {/* Bubble 的 Hero 圖片 */}
                                                    {/* <Row gutter={16}>
                                                        <Col span={12}>
                                                            <Form.Item label="主圖連結" name={[bubbleField.name, 'heroImageUrl']}>
                                                                <Input prefix={<FileImageOutlined style={{ color: '#ccc' }} />} placeholder="https://..." allowClear />
                                                            </Form.Item>

                                                        </Col>
                                                        <Col span={12} style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Upload
                                                                name="msgImg"
                                                                listType="picture"
                                                                fileList={fileList}
                                                                maxCount={1}
                                                                beforeUpload={beforeUpload}
                                                                onChange={handleUploadChange}
                                                                onRemove={handleRemove}
                                                                showUploadList={false}
                                                            >
                                                                <Button icon={<UploadOutlined />}>上傳圖片</Button>
                                                            </Upload>
                                                        </Col>
                                                    </Row> */}
                                                    <Form.Item label="主圖圖片連結" name={[bubbleField.name, 'heroImageUrl']}>
                                                        {/* 使用自定義的上傳組件 */}
                                                        <ImageUploadInput placeholder="主圖網址" />
                                                    </Form.Item>
                                                    {/* <Form.Item label="主圖轉跳連結" name={[bubbleField.name, 'heroUrl']} style={{ marginBottom: 0 }}>
                                                        <Input size="small" placeholder="連結 https://..." />
                                                    </Form.Item> */}
                                                    <Row gutter={8} style={{ marginBottom: 8 }}>
                                                        <Col span={8}>
                                                            <Form.Item label="點擊主圖動作" name={[bubbleField.name, 'heroAction']} initialValue="none">
                                                                <Select size="small" style={{ width: '100%' }}>
                                                                    <Select.Option value="none">無動作</Select.Option>
                                                                    <Select.Option value="uri">連結轉跳</Select.Option>
                                                                    <Select.Option value="message">於聊天室回傳訊息</Select.Option>
                                                                    <Select.Option value="tel">撥打電話</Select.Option>
                                                                    <Select.Option value="email">傳送電子郵件</Select.Option>
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item name={[bubbleField.name, 'heroUri']} style={{ marginBottom: 0 }} label='按鈕連結/訊息/電話/電子郵件'>
                                                                <Input size="small" placeholder="請輸入 按鈕連結 / 訊息 / 電話 / 電子郵件" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item label="比例" name={[bubbleField.name, 'heroAspectRatio']} initialValue="20:13" style={{ marginBottom: 0 }}>
                                                                <Select size="small">
                                                                    <Select.Option value="20:13">20:13</Select.Option>
                                                                    <Select.Option value="300:165">300:165</Select.Option>
                                                                    <Select.Option value="1:1">1:1</Select.Option>
                                                                </Select>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>

                                                    <Divider orientation="left" style={{ margin: '12px 0' }}><Text type="secondary" style={{ fontSize: '12px' }}>內容元素 (Body)</Text></Divider>

                                                    {/* Bubble 內的 Items 列表 */}
                                                    <Form.List name={[bubbleField.name, 'items']}>
                                                        {(itemFields, { add: addItem, remove: removeItem }) => {

                                                            const MAX_IMAGE_COUNT = 5;

                                                            const imageCount = itemFields.filter(
                                                                itemField =>
                                                                    form.getFieldValue(['bubbles', bubbleField.name, 'items', itemField.name, 'type']) === 'image'
                                                            ).length;

                                                            return (
                                                                <div style={{ background: '#f0f2f5', padding: '10px', borderRadius: '4px' }}>

                                                                    {/* 渲染現有的 Items */}
                                                                    {itemFields.map(itemField => {
                                                                        const type = form.getFieldValue(['bubbles', bubbleField.name, 'items', itemField.name, 'type']);
                                                                        return renderContentItemEditor(itemField, removeItem, type);
                                                                    })}

                                                                    {itemFields.length === 0 && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暫無內容" style={{ margin: '10px 0' }} />}

                                                                    {/* 新增元素的按鈕區 (針對這個 Bubble) */}
                                                                    <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                                                                        <Button
                                                                            block type="dashed" size="small"
                                                                            icon={<FontSizeOutlined />}
                                                                            onClick={() => addItem({ type: 'text', content: '', size: 'md' })}
                                                                        >+ 文字</Button>
                                                                        <Button
                                                                            block type="dashed" size="small"
                                                                            icon={<FileImageOutlined />}
                                                                            onClick={() => addItem({ type: 'image', url: '', aspectRatio: '1.91:1' })}
                                                                            disabled={imageCount >= MAX_IMAGE_COUNT}
                                                                        >+ 圖片</Button>
                                                                        <Button
                                                                            block type="dashed" size="small"
                                                                            icon={<InteractionOutlined />}
                                                                            onClick={() => addItem({ type: 'button', label: '按鈕', style: 'link' })}
                                                                        >+ 按鈕</Button>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }}
                                                    </Form.List>
                                                </Card>
                                            );
                                        })}

                                        {/* 輪播模式下：新增圖卡的按鈕 */}
                                        {layoutMode === 'carousel' && (
                                            <Button
                                                type="dashed"
                                                block
                                                style={{ height: '50px', borderColor: '#1890ff', color: '#1890ff' }}
                                                icon={<PlusOutlined />}
                                                onClick={() => addBubble({ items: [{ type: 'text', content: '新圖卡' }] })}
                                                disabled={bubbleFields.length >= 10}
                                            >
                                                新增一張輪播圖卡
                                            </Button>
                                        )}
                                    </div>
                                )}
                            </Form.List>
                        </Form>
                    </div>

                    {/* --- 右側預覽區 --- */}
                    <div style={{ width: '450px', background: '#333', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ padding: '12px 16px', background: '#222', borderBottom: '1px solid #444', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text style={{ color: '#fff', fontWeight: 'bold' }}>即時預覽</Text>
                            <Button size="small" type="text" icon={<CopyOutlined />} style={{ color: '#aaa' }} onClick={() => {
                                navigator.clipboard.writeText(JSON.stringify(previewJson.contents, null, 2));
                                message.success('已複製 JSON');
                            }}>複製 JSON</Button>
                        </div>
                        <div style={{ flex: 1, padding: '10px', overflow: 'auto' }}>
                            <FlexPreview json={previewJson} />
                        </div>
                    </div>

                </div>
            </Modal >
        );
    };

    const SummaryModal = () => {

        const summaryColumns = [
            {
                title: '單位',
                dataIndex: 'dept',
                key: 'dept',
            },
            {
                title: '發送總則數（以發送人數計）',
                dataIndex: 'mount',
                key: 'mount',
            }
        ]

        const handleDownloadSummary = () => {
            let { endTime, startTime } = summaryQueryForm.getFieldsValue();
            endTime = endTime ? dayjs(endTime).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
            startTime = startTime ? dayjs(startTime).format('YYYY-MM-DD') : dayjs().subtract(1, 'month').format('YYYY-MM-DD');
            const userId = secureStorage.getItem('userId');
            const downloadLink = `${process.env.REACT_APP_BASE_URL}/dashboard/toyota_mgmt/broadcast_maintenance/download_broadcast_msg_summary?user_id=${userId}&start_time=${startTime}&end_time=${endTime}`;
            window.open(downloadLink, '_blank');
        }

        return (
            <Modal
                title={<Title level={4} style={{ margin: 0 }}>推播彙整</Title>}
                visible={isSummaryModalVisible}
                onCancel={() => {
                    summaryQueryForm.resetFields()
                    setIsSummaryModalVisible(false);
                }}
                onOk={() => {
                    getSummaryData()
                }}
                okText="查詢推播彙整"
                cancelText="取消"
                footer={null}
                width={1000}
                destroyOnClose={true}
            >
                <Form
                    form={summaryQueryForm}
                    layout="vertical"
                // initialValues={{
                //     date: selectedMsg.sending_time ? dayjs(selectedMsg.sending_time) : dayjs().add(1, 'day'), // 預設明天
                //     time: selectedMsg.sending_time ? dayjs(selectedMsg.sending_time) : dayjs().set('hour', 10).set('minute', 0) // 預設早上 10:00
                // }}
                >
                    {/* --- 彙整時間設定 --- */}
                    <Row gutter={16} style={{ marginBottom: '10px' }} align="middle">

                        <Col span={12}>
                            <Form.Item label={<Text strong>起始日期:</Text>} name="startTime">
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format="YYYY/MM/DD"
                                    suffixIcon={<CalendarOutlined style={{ color: '#8c8c8c' }} />}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={<Text strong>結束日期:</Text>} name="endTime">
                                <DatePicker
                                    style={{ width: '100%' }}
                                    format="YYYY/MM/DD"
                                    suffixIcon={<CalendarOutlined style={{ color: '#8c8c8c' }} />}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider style={{ margin: '10px 0' }} />

                </Form>
                <Table
                    columns={summaryColumns}
                    loading={loading}
                    dataSource={summayTableData}
                    pagination={summaryTableParams.pagination}
                    onChange={handleSummaryTableChange}
                />

                {/* --- 底部按鈕區塊 --- */}
                <div style={{ textAlign: 'right', paddingTop: '20px', borderTop: '1px solid #f0f0f0', marginTop: '20px' }}>
                    <Space>
                        <Button
                            onClick={() => {
                                summaryQueryForm.resetFields()
                                setIsSummaryModalVisible(false);
                            }}
                        >
                            取消
                        </Button>
                        <Button
                            type="primary"
                            icon={<ArrowDownOutlined />}
                            onClick={() => handleDownloadSummary()}
                        >
                            匯出訊息彙整
                        </Button>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                getSummaryData()
                            }}
                            style={{ backgroundColor: '#52C41A' }}
                        // disabled={targetUserIds.length === 0}
                        >
                            重新搜尋訊息彙整
                        </Button>
                    </Space>
                </div>
            </Modal>
        );
    };

    const section = [
        {
            hasTitle: false,
            title: 'Search',
            children: <MsgSearchBar />,
        },
        {
            hasTitle: false,
            title: 'Search',
            children: <MsgDataTable />,
        },
        {
            hasTitle: false,
            title: 'Edit and Modal',
            children: <EditModal form={msgEditForm} loading={apiLoading} />,
        },
        {
            hasTitle: false,
            title: 'Sending Setting Modal',
            children: <SummaryModal />,
        },

    ]

    useEffect(() => {
        getMsgData();
    }, []);

    return (
        <Spin spinning={apiLoading} tip="讀取中..." style={{ height: '100vh' }}>
            <PageHeader functionName={'toyota_broadcast_review'}></PageHeader>
            <PageBody section={section}></PageBody>
        </Spin>
    );
}

export default BroadcastReview;